export const EMPLOYEE_NUMBER_OF_HOLIDAYS = 10;
